import { useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { fonts } from "../../../styles/theme";
import { Etiqueta, Meta, cores } from "../../relatorio/styles";
import { linkDoWhatsApp, situacaoDoPedido } from "../pages/acesso";
import type { PedidoDeAcesso } from "../types";

const Botaozinho = styled.button<{ $cor?: string }>`
  border: 1px solid ${cores.line};
  background: #fff;
  color: ${({ $cor }) => $cor ?? cores.blue};
  font-family: ${fonts.gilroySemiBold}, sans-serif;
  font-size: 13px;
  border-radius: 1000px;
  padding: 8px 14px;
  cursor: pointer;
  white-space: nowrap;
  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;

const Acoes = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

type Props = {
  pedido: PedidoDeAcesso | null | undefined;
  gerando: boolean;
  onGerar: () => void;
};

/**
 * Botões do "acesso pelo cliente" ao lado de um perfil sem acesso: gera o link,
 * copia, abre no WhatsApp e mostra em que pé o pedido está.
 */
export const LinkDeAcesso = ({ pedido, gerando, onGerar }: Props) => {
  const [copiado, setCopiado] = useState(false);
  const vencido = pedido ? new Date(pedido.expiresAt).getTime() < Date.now() : false;
  const situacao = pedido ? situacaoDoPedido(pedido) : null;

  const copiar = async () => {
    if (!pedido) return;
    try {
      await navigator.clipboard.writeText(pedido.link);
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    } catch {
      toast.info(pedido.link);
    }
  };

  return (
    <Acoes>
      {situacao && (
        <Etiqueta $cor={vencido && pedido?.status !== "CONCLUIDO" ? "cinza" : situacao.cor} title={pedido?.errorMessage ?? undefined}>
          {vencido && pedido?.status !== "CONCLUIDO" ? "Link vencido" : situacao.rotulo}
        </Etiqueta>
      )}
      {pedido && pedido.status !== "CONCLUIDO" && !vencido && (
        <>
          <Botaozinho type="button" onClick={copiar}>{copiado ? "Copiado!" : "Copiar link"}</Botaozinho>
          <Botaozinho type="button" as="a" href={linkDoWhatsApp(pedido.whatsappText)} target="_blank" rel="noopener noreferrer" $cor="#188038">
            WhatsApp
          </Botaozinho>
        </>
      )}
      {(!pedido || pedido.status === "ERRO" || vencido) && pedido?.status !== "CONCLUIDO" && (
        <Botaozinho type="button" onClick={onGerar} disabled={gerando}>
          {gerando ? "Gerando…" : pedido ? "Gerar novo link" : "Link para o cliente"}
        </Botaozinho>
      )}
      {pedido?.status === "ERRO" && pedido.errorMessage && (
        <Meta style={{ flexBasis: "100%", color: cores.red, textAlign: "right" }}>{pedido.errorMessage}</Meta>
      )}
    </Acoes>
  );
};
